module.exports = __webpack_public_path__ + "static/media/fretador-fundo.814a7e00.png";